import { FieldError, UseFormMethods, RegisterOptions } from "react-hook-form";
import classnames from "classnames";

import "./CheckBoxInput.styles.scss";

interface CheckBoxInputProps {
  register: UseFormMethods["register"];
  rules?: RegisterOptions;
  placeholder?: string;
  dataRecurly?: string;
  disabled?: boolean;
  optional?: boolean;
  error?: FieldError;
  label: string | JSX.Element;
  help?: string;
  name: string;
}

export function CheckBoxInput({
  register,
  dataRecurly,
  placeholder,
  disabled,
  optional,
  error,
  rules,
  label,
  name,
  help,
}: CheckBoxInputProps) {
  return (
    <div className="form-ctrl form-ctrl-checkbox">
      <input
        className={classnames({ "has-error": !!error })}
        aria-invalid={error ? "true" : "false"}
        ref={register(rules)}
        // do that to hide the original checkbox look but tell screen-readers it's there
        aria-hidden={false}
        hidden={true}
        type="checkbox"
        id={name}
        name={name}
        {...(dataRecurly ? { "data-recurly": dataRecurly } : {})}
        {...(placeholder ? { placeholder } : {})}
        {...(disabled ? { disabled } : {})}
      />
      <label className={classnames({ optional })} htmlFor={name}>
        {label}
      </label>
      {error ? <span className="form-error">{error.message || "Error"}</span> : null}
      {help ? <span className="form-help">{help}</span> : null}
    </div>
  );
}
